export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: '/batch-upgradation/wizard',
      name: 'BatchUpgradationWizard',
      component: () => import('@/views/batch-upgradation/BatchUpgradationWizard.vue'),
    },
  ],
}
